export function formatBps(value: number): string {
  return `${Math.floor(value / 100)}.${String(value % 100).padStart(2, "0")}%`;
}

